import HowToCleanDevice from './HowToCleanDevice';
export default HowToCleanDevice;
